import api from '~/api'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  getUser(ctx, id) {
    return api.get(`/users/${id}`)
  },
  createUser(ctx, { form, options = {} }) {
    return api.post('/users', form, options)
  },
  updateUser(ctx, { id, form, options = {} }) {
    return api.put(`/users/${id}`, form, options)
  },
  deleteUser(ctx, { id, options = {} }) {
    return api.delete(`/users/${id}`, options)
  },
  sendPasswordChangeEmail(_, id) {
    return api.post(`/users/${id}/password-change-emails`)
  },
  resendVerificationEmail(store, id) {
    return api.post(`/users/${id}/verification-emails`)
  },
  resendWelcomeEmail(store, id) {
    return api.post(`/users/${id}/welcome-emails`)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
